import { esc } from '@/utils/escape';

export function generateCookieHTML(data: any, settings: any): string {
  // Swiss-grade: category-based consent + preference center + script blocking
  return `  <!-- Cookie Banner -->
  <div class="cookie-banner" id="cookie-banner" role="dialog" aria-live="polite" aria-label="Cookie Hinweis">
    <h4>${esc(data.title || "Cookie-Einstellungen")}</h4>
    <p>${esc(data.text || "")} <a href="${esc(data.policyLink || "datenschutz.html")}" rel="noopener noreferrer">Mehr erfahren</a></p>
    <div class="cookie-banner__actions">
      <button class="cookie-banner__necessary" id="cookie-necessary" type="button">${esc(data.acceptNecessary || "Nur notwendige")}</button>
      <button class="cookie-banner__reject" id="cookie-reject" type="button">${esc(data.acceptReject || "Ablehnen")}</button>
      ${data.showSettingsButton !== false ? `<button class="cookie-banner__settings" id="cookie-settings" type="button">${esc(data.openSettings || "Einstellungen")}</button>` : ``}
      <button class="cookie-banner__all" id="cookie-accept" type="button">${esc(data.acceptAll || "Alle akzeptieren")}</button>
    </div>
  </div>

  <!-- Cookie Preference Center -->
  <div class="cookie-modal" id="cookie-modal" aria-hidden="true">
    <div class="cookie-modal__panel" role="dialog" aria-modal="true" aria-label="Cookie Einstellungen">
      <div class="cookie-modal__header">
        <div>
          <h4>${esc(data.preferencesTitle || "Cookie-Einstellungen")}</h4>
          <p style="margin:8px 0 0;color:var(--c-text-muted);">${esc(data.preferencesText || "Wählen Sie aus, welche Cookies wir verwenden dürfen. Notwendige Cookies sind immer aktiv.")}</p>
        </div>
        <button class="cookie-modal__close" id="cookie-modal-close" type="button" aria-label="Schliessen">×</button>
      </div>

      <div class="cookie-prefs">
        <div class="cookie-pref">
          <div class="cookie-pref__meta">
            <strong>${esc(data.necessaryLabel || "Notwendig")}</strong>
            <span>Grundfunktionen, Sicherheit, Spracheinstellungen.</span>
          </div>
          <label class="cookie-toggle">
            <input type="checkbox" checked disabled aria-label="Notwendige Cookies aktiv">
          </label>
        </div>

        <div class="cookie-pref">
          <div class="cookie-pref__meta">
            <strong>${esc(data.statisticsLabel || "Statistik")}</strong>
            <span>Anonyme Reichweitenmessung zur Verbesserung der Website.</span>
          </div>
          <label class="cookie-toggle">
            <input id="cookie-statistics" type="checkbox" aria-label="Statistik Cookies">
          </label>
        </div>

        <div class="cookie-pref">
          <div class="cookie-pref__meta">
            <strong>${esc(data.marketingLabel || "Marketing")}</strong>
            <span>Personalisierung und Marketing-Tracking (optional).</span>
          </div>
          <label class="cookie-toggle">
            <input id="cookie-marketing" type="checkbox" aria-label="Marketing Cookies">
          </label>
        </div>
      </div>

      <div class="cookie-modal__actions">
        <button class="btn btn--secondary" id="cookie-save" type="button">${esc(data.savePreferences || "Speichern")}</button>
        <button class="btn btn--primary" id="cookie-accept-all" type="button">${esc(data.acceptAll || "Alle akzeptieren")}</button>
      </div>

      <p style="margin-top:14px;color:var(--c-text-muted);font-size:var(--text-sm);">
        <a class="cookie-manage-link" href="${esc(data.policyLink || "datenschutz.html")}" rel="noopener noreferrer">Datenschutz</a>
        · <a class="cookie-manage-link" href="#" data-open-cookie-settings="1">${esc(data.manageLinkText || "Cookie-Einstellungen")}</a>
      </p>
    </div>
  </div>

  <script>
  (function(){
    if (window.__sbCookieInit) return;
    window.__sbCookieInit = true;

    var KEY = 'cookie-consent-v2';
    var LEGACY = 'cookie-consent'; // older string key
    var CONSENT_VERSION = 2; /* QA: E-2 — Consent versioning */
    var VERSION_KEY = 'cookie-consent-version'; /* QA: E-2 */
    var banner = document.getElementById('cookie-banner');
    var modal = document.getElementById('cookie-modal');

    function parseConsent(raw){
      try { return JSON.parse(raw || ''); } catch(e){ return null; }
    }

    function getConsent(){
      var v2 = parseConsent(localStorage.getItem(KEY));
      if (v2 && typeof v2 === 'object') return v2;

      // Legacy compatibility: 'all' | 'necessary'
      var legacy = localStorage.getItem(LEGACY);
      if (legacy === 'all') return { necessary:true, statistics:true, marketing:true };
      if (legacy === 'necessary') return { necessary:true, statistics:false, marketing:false };

      // Default (privacy-by-default)
      return {
        necessary: true,
        statistics: ${data.defaultStatistics ? "true" : "false"},
        marketing: ${data.defaultMarketing ? "true" : "false"}
      };
    }

    function setConsent(consent){
      localStorage.setItem(KEY, JSON.stringify(consent));
      localStorage.setItem('cookie-consent-date', new Date().toISOString());
      localStorage.setItem(VERSION_KEY, String(CONSENT_VERSION)); /* QA: E-2 */
    }

    function hasStoredConsent(){
      var stored = !!localStorage.getItem(KEY) || !!localStorage.getItem(LEGACY);
      if (!stored) return false;
      /* QA: E-2 — Version mismatch → re-show banner */
      var storedVersion = parseInt(localStorage.getItem(VERSION_KEY), 10);
      if (storedVersion !== CONSENT_VERSION) return false;
      return true;
    }

    function showBanner(){ if (banner) banner.classList.remove('hidden'); }
    function hideBanner(){ if (banner) banner.classList.add('hidden'); }

    /* QA: B-4 — Focus-Trap for Cookie Modal */
    var modalTrigger = null;
    var modalFocusTrapHandler = null;

    function trapFocusInContainer(container) {
      var focusable = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      first.focus();
      modalFocusTrapHandler = function(e) {
        if (e.key !== 'Tab') return;
        var els = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var f = els[0], l = els[els.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === f) { e.preventDefault(); l.focus(); }
        } else {
          if (document.activeElement === l) { e.preventDefault(); f.focus(); }
        }
      };
      document.addEventListener('keydown', modalFocusTrapHandler);
    }

    function openModal(){
      if (!modal) return;
      modalTrigger = document.activeElement; /* QA: B-4 — remember trigger */
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      // sync checkboxes
      var c = getConsent();
      var stats = document.getElementById('cookie-statistics');
      var mkt = document.getElementById('cookie-marketing');
      if (stats) stats.checked = !!c.statistics;
      if (mkt) mkt.checked = !!c.marketing;
      trapFocusInContainer(modal.querySelector('.cookie-modal__panel') || modal); /* QA: B-4 */
    }

    function closeModal(){
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      /* QA: B-4 — release focus trap and restore focus */
      if (modalFocusTrapHandler) {
        document.removeEventListener('keydown', modalFocusTrapHandler);
        modalFocusTrapHandler = null;
      }
      if (modalTrigger && modalTrigger.focus) { modalTrigger.focus(); modalTrigger = null; }
    }

    function allowCategory(cat){
      var c = getConsent();
      if (cat === 'necessary') return true;
      return !!c[cat];
    }

    function hydrateScripts(){
      // Load blocked scripts
      var scripts = document.querySelectorAll('script[type="text/plain"][data-consent]');
      scripts.forEach(function(s){
        var cat = (s.getAttribute('data-consent') || '').toLowerCase();
        if (!cat) return;
        if (!allowCategory(cat)) return;

        var n = document.createElement('script');
        // copy src or inline
        var src = s.getAttribute('data-src') || s.getAttribute('src');
        if (src) n.src = src;
        if (s.hasAttribute('async')) n.async = true;
        if (s.hasAttribute('defer')) n.defer = true;
        // inline code
        if (!src) n.text = s.text || s.textContent || '';
        // replace
        s.parentNode.insertBefore(n, s);
        s.parentNode.removeChild(s);
      });

      // Unhide consent-gated elements (optional)
      document.querySelectorAll('[data-requires-consent]').forEach(function(el){
        var cat = (el.getAttribute('data-requires-consent') || '').toLowerCase();
        if (allowCategory(cat)) el.classList.remove('is-consent-hidden');
      });
    }

    function applyConsent(){
      hydrateScripts();
      // broadcast
      try{
        window.dispatchEvent(new CustomEvent('sb:consent', { detail: getConsent() }));
      }catch(e){}
    }

    // Attach handlers
    var btnAll = document.getElementById('cookie-accept');
    var btnNec = document.getElementById('cookie-necessary');
    var btnRej = document.getElementById('cookie-reject');
    var btnSet = document.getElementById('cookie-settings');
    var btnSave = document.getElementById('cookie-save');
    var btnAcceptAll = document.getElementById('cookie-accept-all');
    var btnClose = document.getElementById('cookie-modal-close');

    if (btnAll) btnAll.addEventListener('click', function(){
      setConsent({ necessary:true, statistics:true, marketing:true });
      hideBanner();
      closeModal();
      applyConsent();
    });

    if (btnAcceptAll) btnAcceptAll.addEventListener('click', function(){
      setConsent({ necessary:true, statistics:true, marketing:true });
      hideBanner();
      closeModal();
      applyConsent();
    });

    if (btnNec) btnNec.addEventListener('click', function(){
      setConsent({ necessary:true, statistics:false, marketing:false });
      hideBanner();
      closeModal();
      applyConsent();
    });

    if (btnRej) btnRej.addEventListener('click', function(){
      setConsent({ necessary:true, statistics:false, marketing:false });
      hideBanner();
      closeModal();
      applyConsent();
    });

    if (btnSet) btnSet.addEventListener('click', function(){ openModal(); });
    if (btnClose) btnClose.addEventListener('click', function(){ closeModal(); });

    if (btnSave) btnSave.addEventListener('click', function(){
      var stats = document.getElementById('cookie-statistics');
      var mkt = document.getElementById('cookie-marketing');
      setConsent({
        necessary:true,
        statistics: !!(stats && stats.checked),
        marketing: !!(mkt && mkt.checked)
      });
      hideBanner();
      closeModal();
      applyConsent();
    });

    document.addEventListener('click', function(e){
      var t = e.target;
      if (t && t.closest && t.closest('[data-open-cookie-settings]')){
        e.preventDefault();
        openModal();
      }
    });

    if (modal) {
      modal.addEventListener('click', function(e){
        if (e.target === modal) closeModal();
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape') closeModal();
      });
    }

    // Initial
    if (!hasStoredConsent()) {
      showBanner();
    } else {
      hideBanner();
      applyConsent();
    }
  })();
  <\/script>`;
}
